export const LocalStorage = {
    getToken(): string | null {
        return window.localStorage.getItem('token')
    },
    setToken(token: string): void | null {
        return window.localStorage.setItem('token', token)
    },
    removeToken(): void | null {
        return window.localStorage.removeItem('token')
    },

    getUser(): string | null {
        return window.localStorage.getItem('user')
    },
    setUser(user: string): void | null {
        return window.localStorage.setItem('user', user)
    },
    removeUser(): void | null {
        return window.localStorage.removeItem('user')
    },
}
